export default __webpack_public_path__ + "static/media/projects.b894a1f8.jpg";